module.exports = __webpack_public_path__ + "img/下载app.206a1404.png";